import { LOCAL_STORAGE_KEYS } from "../consts/localStorage";
import { unwrapOr } from "./general";

/**
 * @returns {unknown | null}
 */
export const getUserId = () => {
  const data = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.userData));
  if (data?.user) {
    return data.user.id;
  }
  return null;
};

/**
 * @returns {unknown | null}
 */
export const getAccountId = () => {
  const data = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.userData));
  if (data && data.account) {
    return data.account.id;
  }
  return null;
};

/**
 * @deprecated Use `useCurrentUserQuery` instead
 */
export const getUser = () => {
  return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.userData));
};

/**
 * @deprecated Try to avoid of using localStorage language data.
 * Use local i18n translations instead
 */
export const getLanguageData = (key) => {
  const data = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEYS.languageData),
  );
  if (data && key in data) {
    return data[key];
  }
  return data || {};
};

/**
 * @deprecated Use `useCurrentUserQuery` or `useCurrentAccountQuery` to access
 * current account payment system
 */
export const getUserPaymentSystem = () => {
  let result = "";
  const userData = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEYS.userData),
  );
  if (userData?.account) {
    result = userData.account.pos_gateway || "";
  }
  return result;
};

/**
 * @deprecated Use `useCurrentAccountQuery` to access
 * current account subscription plan
 */
export const getAccountSubscriptionPlan = () => {
  return localStorage.getItem(LOCAL_STORAGE_KEYS.subscriptionPlan);
};

/**
 * @deprecated Use `useCurrentAccountQuery` to access
 * clients alias
 */
export const getClientsLabel = () => {
  const data =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.languageData)) || {};
  return data.header_clients;
};

/**
 * @returns {string | null}
 */
export const clinicTimezone = {
  get: () => localStorage.getItem(LOCAL_STORAGE_KEYS.clinicTimezone),

  set: (value) =>
    localStorage.setItem(LOCAL_STORAGE_KEYS.clinicTimezone, value),

  remove: () => localStorage.removeItem(LOCAL_STORAGE_KEYS.clinicTimezone),
};

/**
 * @deprecated Use `useCurrentUserQuery` if possible
 */
export const getIsMainAdmin = () => {
  const data = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.userData));
  const adminId = data?.account?.admin_id;
  const userId = data?.user?.id;

  return Boolean(adminId && userId && adminId === userId);
};

export const lockAppUntilAccountAddressUpdated = {
  get: () =>
    JSON.parse(
      localStorage.getItem(
        LOCAL_STORAGE_KEYS.lockAppUntilAccountAddressUpdated,
      ),
    ),

  set: (value) =>
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.lockAppUntilAccountAddressUpdated,
      JSON.stringify(value),
    ),

  remove: () =>
    localStorage.removeItem(
      LOCAL_STORAGE_KEYS.lockAppUntilAccountAddressUpdated,
    ),
};

export const lockAppUntilAccount2FaEnabled = {
  get: () =>
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.lockAppUntil2FAEnabled)),

  set: (value) =>
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.lockAppUntil2FAEnabled,
      JSON.stringify(value),
    ),

  remove: () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.lockAppUntil2FAEnabled);
  },
};

export const wpuId = {
  get: () => {
    const id = parseInt(localStorage.getItem(LOCAL_STORAGE_KEYS.wpuId));
    return id || undefined;
  },

  set: (value) => localStorage.setItem(LOCAL_STORAGE_KEYS.wpuId, value),

  remove: () => localStorage.removeItem(LOCAL_STORAGE_KEYS.wpuId),
};

/**
 * This local storage key should not be cleared on logout.
 * Do not add it to LOCAL_STORAGE_KEYS
 */
export const trustedDeviceToken = (() => {
  const key = "_tdt";

  const remove = () => localStorage.removeItem(key);

  const get = () =>
    unwrapOr(() => {
      const data = JSON.parse(localStorage.getItem(key));
      if (Array.isArray(data)) {
        return data;
      }
      remove();
      return [];
    }, []);

  const set = ({ user, token }) => {
    const currentTokens = get();
    const existingIndex = currentTokens.findIndex((item) => item.user === user);

    if (existingIndex !== -1) {
      currentTokens[existingIndex] = { user, token };
    } else {
      currentTokens.push({ user, token });
    }

    localStorage.setItem(key, JSON.stringify(currentTokens));
  };

  return { get, set, remove };
})();
